import React from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, CircularProgress } from '@mui/material';

export default function DialogLoader({ open }) {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      aria-labelledby="dialog-loader"
      PaperProps={{
        sx: {
          borderRadius: '18px',
          bgcolor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(6px)',
          boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
          p: 2,
          m: 1,
          overflow: 'hidden',
          minWidth: 'unset',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      BackdropProps={{
        sx: {
          bgcolor: 'rgba(15, 23, 42, 0.25)',
          backdropFilter: 'blur(2px)',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          width: 52,
          height: 52,
        }}
      >
        <CircularProgress
          size={50}
          thickness={3.2}
          sx={{
            color: '#0492D4',
            animationDuration: '1.1s',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none',
          }}
        >
          <img
            src="/img/aszento.png?v=2"
            alt="Aszento"
            style={{ width: '22px', height: 'auto', display: 'block' }}
          />
        </Box>
      </Box>
    </Dialog>
  );
}

DialogLoader.propTypes = {
  open: PropTypes.bool.isRequired,
};
